import React from "react";
import { Box, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import PageHeading from "../components/layouts/PageHeading";
import ProgressBar from "../components/ProgressBar";
import ClientAudit from "../components/forms/ClientAudit";
import MultiStepForm2 from "../components/forms/MultiStepForm2";

const formSections = [
  "Renseignements du client",
  "Bilan Énergétique",
  "Solutions Énergétique",
  "Économies Énergétique",
];

const PartTwo = () => {
  const navigate = useNavigate();
  const currentSection = 1; // Index of the current section for the progress bar

  const handleFormSubmit = () => {
    navigate("/client-energetique"); // Assuming you have a route set up for the second part
    window.scrollTo(0, 0);
  };

  return (
    <Box width="full">
      <Box position="sticky" h={"140px"} top={0} bg="white" zIndex={1}>
        <ProgressBar sections={formSections} currentSection={currentSection} />
      </Box>
      <MultiStepForm2 onSubmit={handleFormSubmit} />
    </Box>
  );
};

export default PartTwo;
